import { type FC, type SetStateAction, type Dispatch, useEffect, useRef } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { FormattedMessage } from 'dibs-react-intl';
import { PdpRespSidebarDetailsSection } from './PdpRespSidebarDetailsSection';
import { PdpSharedBuyerIncentives } from '../shared/PdpSharedBuyerIncentives/PdpSharedBuyerIncentives';

// types
import { type PdpRespSidebarDetailsPromise_user$key as User } from './__generated__/PdpRespSidebarDetailsPromise_user.graphql';

// styles
import styles from './PdpRespSidebarDetailsPromise.module.css';

const DibsPromise = (
    <FormattedMessage
        id="PdpRespSidebarDetailsPromise.promise"
        defaultMessage="The 1stDibs Promise"
    />
);

const userFragment = graphql`
    fragment PdpRespSidebarDetailsPromise_user on User {
        ...PdpSharedBuyerIncentives_user
    }
`;

export const PdpRespSidebarDetailsPromise: FC<{
    user: User | null;
    expandOverrideState: [boolean, Dispatch<SetStateAction<boolean>>];
}> = ({ user: userRef, expandOverrideState }) => {
    const user = useFragment(userFragment, userRef);
    const promiseSectionRef = useRef<HTMLDivElement>(null);
    const [shouldOpen, setShouldOpen] = expandOverrideState;

    useEffect(() => {
        if (shouldOpen && promiseSectionRef.current) {
            promiseSectionRef.current.scrollIntoView({ behavior: 'smooth' });
            setShouldOpen(false);
        }
    }, [shouldOpen, setShouldOpen]);

    return (
        <>
            <div ref={promiseSectionRef} className={styles.scrollDiv} />
            <PdpRespSidebarDetailsSection
                title={DibsPromise}
                expandOverride={shouldOpen}
                ga={{ trigger: 'buyer incentives' }}
            >
                <PdpSharedBuyerIncentives
                    user={user}
                    columnLayoutOverride
                    isPDPDesktopAggregationVariant
                />
            </PdpRespSidebarDetailsSection>
        </>
    );
};
